<template>
    <v-card>
        <v-card-title>
            <span class="primary--text title">
                {{ caseDetails.patient_name }}
            </span>
            <v-spacer></v-spacer>
            <v-btn icon @click="closeDialog()">
                <v-icon>
                    mdi-close
                </v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col md="6" lg="6" xl="6">
                    <SidebarCaseCardDetail
                        name="Case Title/ Health Concern"
                        :value="caseDetails.health_concern | convertToNotApplicable"
                    ></SidebarCaseCardDetail>
                    <SidebarCaseCardDetail
                        name="Case No."
                        :value="caseDetails.case_number | convertToNotApplicable"
                    ></SidebarCaseCardDetail>
                    <SidebarCaseCardDetail
                        name="Case"
                        :value="caseDetails.id | caseNumberText | convertToNotApplicable"
                    ></SidebarCaseCardDetail>
                    <SidebarCaseCardDetail
                        name="Consultations"
                        :value="caseDetails.consultations | consultationText | convertToNotApplicable"
                    ></SidebarCaseCardDetail>
                    <SidebarCaseCardDetail
                        name="Preferred Call Method"
                        :value="caseDetails.preferred_call_method | convertToNotApplicable"
                    ></SidebarCaseCardDetail>
                    <SidebarCaseCardDetail
                        name="Preferred Call Date"
                        :value="caseDetails.preferred_call_datetime | convertToScheduleDateTime | convertToNotApplicable"
                    ></SidebarCaseCardDetail>
                    <SidebarCaseCardDetail
                        name="VIP"
                        :value="caseDetails.is_vip | convertToYesNoText"
                    ></SidebarCaseCardDetail>
                    <SidebarCaseCardDetail
                        name="Warning"
                        :value="caseDetails.has_warning | convertToYesNoText"
                    ></SidebarCaseCardDetail>
                    <SidebarCaseCardDetail
                        name="Warning Reason"
                        :value="caseDetails.warning_reason | convertToNotApplicable"
                    ></SidebarCaseCardDetail>
                    <SidebarCaseCardDetail
                        name="Status"
                        :value="caseDetails.status | convertToNotApplicable"
                    ></SidebarCaseCardDetail>
                </v-col>
                <v-col md="6" lg="6" xl="6">
                    <SidebarCaseCardDetail
                        name="Language"
                        :value="caseDetails.language | convertToNotApplicable"
                    ></SidebarCaseCardDetail>
                    <SidebarCaseCardDetail
                        name="Gender"
                        :value="caseDetails.gender | convertToNotApplicable"
                    ></SidebarCaseCardDetail>
                    <SidebarCaseCardDetail
                        name="Birthdate"
                        :value="caseDetails.birthdate | convertToNotApplicable"
                    ></SidebarCaseCardDetail>
                    <SidebarCaseCardDetail
                        name="Age"
                        :value="caseDetails.age | convertToNotApplicable"
                    ></SidebarCaseCardDetail>
                    <SidebarCaseCardDetail
                        name="Marital Status"
                        :value="caseDetails.marital_status | convertToNotApplicable"
                    ></SidebarCaseCardDetail>
                    <SidebarCaseCardDetail
                        name="Email"
                        :value="caseDetails.email | convertToNotApplicable"
                    ></SidebarCaseCardDetail>
                    <SidebarCaseCardDetail
                        name="Mobile No."
                        :value="caseDetails.mobile_number | convertToNotApplicable"
                    ></SidebarCaseCardDetail>
                    <SidebarCaseCardDetail
                        name="Company"
                        :value="caseDetails.company | convertToNotApplicable"
                    ></SidebarCaseCardDetail>
                    <SidebarCaseCardDetail
                        name="Insurance Provider"
                        :value="caseDetails.insurance_provider | convertToNotApplicable"
                    ></SidebarCaseCardDetail>
                    <SidebarCaseCardDetail
                        name="Insurance No."
                        :value="caseDetails.insurance_number | convertToNotApplicable"
                    ></SidebarCaseCardDetail>
                </v-col>
            </v-row>
            <div class="text-h6 font-weight-bold">
                Health Information
            </div>
            <v-row>
                <v-col md="6" lg="6" xl="6">
                    <SidebarCaseCardDetail
                        name="Relevant Social Factors"
                        :value="caseDetails.social_factors | convertToNotApplicable"
                    ></SidebarCaseCardDetail>
                    <SidebarCaseCardDetail
                        name="Illness/ Injury"
                        :value="caseDetails.illness_injury | convertToNotApplicable"
                    ></SidebarCaseCardDetail>
                    <SidebarCaseCardDetail
                        name="Dietary Status"
                        :value="caseDetails.dietary_status | convertToNotApplicable"
                    ></SidebarCaseCardDetail>
                    <SidebarCaseCardDetail
                        name="Immunization"
                        :value="caseDetails.immunizations | convertToNotApplicable"
                    ></SidebarCaseCardDetail>
                    <SidebarCaseCardDetail
                        name="Hospitalization"
                        :value="caseDetails.hospitalizations | convertToNotApplicable"
                    ></SidebarCaseCardDetail>
                    <SidebarCaseCardDetail
                        name="Operation"
                        :value="caseDetails.operations | convertToNotApplicable"
                    ></SidebarCaseCardDetail>
                </v-col>
                <v-col md="6" lg="6" xl="6">
                    <SidebarCaseCardDetail
                        name="Smoking Habit"
                        :value="caseDetails.smoking_habit | convertToNotApplicable"
                    ></SidebarCaseCardDetail>
                    <SidebarCaseCardDetail
                        name="Alcohol Habit"
                        :value="caseDetails.alcohol_habit | convertToNotApplicable"
                    ></SidebarCaseCardDetail>
                    <SidebarCaseCardDetail
                        name="Blood Type"
                        :value="caseDetails.blood_type | convertToNotApplicable"
                    ></SidebarCaseCardDetail>
                    <SidebarCaseCardDetail
                        name="Period Last Started"
                        :value="caseDetails.period_last_start | convertToNotApplicable"
                    ></SidebarCaseCardDetail>
                    <SidebarCaseCardDetail
                        name="Period Length"
                        :value="caseDetails.period_length | convertToNotApplicable"
                    ></SidebarCaseCardDetail>
                    <SidebarCaseCardDetail
                        name="Period Typical Cycle"
                        :value="caseDetails.period_typical_cycle | convertToNotApplicable"
                    ></SidebarCaseCardDetail>
                    <SidebarCaseCardDetail
                        name="Medications"
                        :value="caseDetails.medications | convertToNotApplicable"
                    ></SidebarCaseCardDetail>
                    <SidebarCaseCardDetail
                        name="Chronic Diseases"
                        :value="caseDetails.chronic_diseases | convertToNotApplicable"
                    ></SidebarCaseCardDetail>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import sidebarCaseDetailMixins from "../sidebar/sidebar-card/js/sidebarCaseDetailMixins";
import DASHBOARD_STORE from "../store/dashboard.module";

export default {
    mixins: [
        sidebarCaseDetailMixins
    ],
    components: {
        SidebarCaseCardDetail: () => import("../sidebar/sidebar-card/SidebarCaseCardDetail")
    },
    computed: {
        caseDetails: function() {
            return this.setDetails(DASHBOARD_STORE.getters.selectedCase);
        }
    },
    methods: {
        closeDialog() {
            DASHBOARD_STORE.commit("showCaseDetails", false);
        },
        setDetails(data) {
            let consultation = data.consultations.length ? data.consultations[0] : [];

            return {
                patient_name: this.getPatientName(data),
                health_concern: data.health_concern,
                case_number: data.case_number,
                id: data.id,
                consultations: data.consultations.length,
                preferred_call_method: consultation.call_method,
                preferred_call_datetime: consultation.call_datetime,
                is_vip: data.patient?.patient?.is_vip || null,
                has_warning: data.patient?.patient?.has_warning || null,
                warning_reason: data.patient?.patient?.warning_reason || null,
                status: data.status,

                language: data.patient?.patient?.preferred_language,
                gender: data.patient?.patient?.gender,
                birthdate: data.patient?.patient?.birthdate,
                age: data.patient?.patient?.gender,
                marital_status: data.patient?.patient?.marital_status,
                email: data.patient?.email,
                mobile_number: data.patient?.patient?.mobile_number,
                company: data.patient?.patient?.company_name,
                insurance_provider: data.patient?.insurance_provider,
                insurance_number: data.patient?.insurance_number,

                social_factors: data.patient?.patient?.social_factors,
                illness_injury: data.patient?.patient?.illness_injury,
                dietary_status: data.patient?.patient?.dietary_status,
                immunizations: data.patient?.patient?.immunizations,
                hospitalizations: data.patient?.patient?.hospitalizations,
                operations: data.patient?.patient?.operations,

                smoking_habit: data.patient?.patient?.smoking_habit,
                alcohol_habit: data.patient?.patient?.alcohol_habit,
                blood_type: data.patient?.patient?.blood_type,
                period_last_start: data.patient?.patient?.period_last_start,
                period_length: data.patient?.patient?.period_length,
                period_typical_cycle: data.patient?.patient?.period_typical_cycle,
                medications: data.patient?.patient?.current_medication,
                chronic_diseases: data.patient?.patient?.chronic_diseases
            };
        },
        getPatientName(data) {
            let patient = data?.patient?.patient || null;

            if(patient) {
                if (patient.full_name) {
                    return patient.full_name;
                } else {
                    return `${patient.first_name} ${patient.middle_name} ${patient.last_name}`;
                }
            }

            return patient;
        }
    }
}
</script>